/**
 * @module components/Form/FormGroupCoordinates
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Button for getting current user location using Bootstrap 3
 */

import { Row, Col, Tabs, Tab } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

import FormGroupGeolocation from './form-group-geolocation-with-fallback';
import ButtonCurrentLocation from './button-current-location';

import FormGroupManualCoordinates from './form-group-manual-coordinates';


type Props = {
  values: FormCoordinates,
  onCoordinates: FormOnCoordinates,
  address: string,
  onAddress: (v: string) => void,
}

/**
 * React component
 * ===============
 */
const FormGroupCoordinates = ({
  values,
  onCoordinates,
  address,
  onAddress,
}: Props) => {
  const [lang] = useLanguageState();

  return (
    <Row>
      <Col sm={2} className='control-label' style={{ fontWeight: 700 }}>
        {lang.form.coordinates}
      </Col>
      <Col sm={10}>
        {lang.form.coordinatesInstructions}
        <Tabs defaultActiveKey={1} id="coordinates-tab">
          <Tab eventKey={1} title={lang.form.coordinatesAddress}>
            <FormGroupGeolocation
              address={address}
              onAddress={onAddress}
              onCoordinates={onCoordinates}
            />
          </Tab>
          <Tab eventKey={2} title={lang.form.coordinatesCurrent}>
            <ButtonCurrentLocation
              onCoordinates={onCoordinates}
            />
          </Tab>
          <Tab eventKey={3} title={lang.form.coordinatesManual}>
            <FormGroupManualCoordinates
              values={values}
              onCoordinates={onCoordinates}
            />
          </Tab>
        </Tabs>
      </Col>
    </Row>
  );
}

export default FormGroupCoordinates;
